export enum AgentStepsSupportedActions {
  chatGptEnterpriseDeleteConversationAction = 'chatGptEnterpriseDeleteConversationAction',
}
